import { GET_RBAC_SUCCESS, GET_RBAC_FAILURE, RBAC_LOADING, SAVE_RBAC_SUCCESS, SAVE_RBAC_FAILURE } from './actions';

import _ from 'lodash';
import createReducer from 'state/createReducer';

const initialState = {
  loading: false,
  roles: [],
  resources: []
};

const handlers = {
  [RBAC_LOADING](state) {
    return {
      ...state,
      loading: true
    };
  },

  [GET_RBAC_SUCCESS](state, payload) {
    return {
      ...state,
      loading: false,
      roles: payload?.roles || [],
      resources: payload?.resources || []
    };
  },

  [GET_RBAC_FAILURE](state) {
    return {
      ...state,
      loading: false
    };
  },

  [SAVE_RBAC_SUCCESS](state) {
    return {
      ...state,
      loading: false
    };
  },

  [SAVE_RBAC_FAILURE](state) {
    return {
      ...state,
      loading: false
    };
  }
};

export default (state = initialState, action) => createReducer(state, action, handlers);
